import { useQuery } from "@tanstack/react-query";
import dashboardService from "src/services/dashboardService";

/**
 * Reads the Dashboard V2 flag for the LOGGED-IN user's own company (set from
 * Company → Settings by a super admin). Keyed to the JWT server-side, so it
 * needs no companyId and works for every company user, not just those with the
 * COMPANY feature permission. The service call is resilient and defaults to
 * { dashboardV2Enabled: false } on any failure, so it never blocks rendering.
 */
export const useCompanyDashboardConfig = () => {
  return useQuery(
    ["dashboardConfig"],
    () => dashboardService.getDashboardConfig(),
    {
      staleTime: 5 * 60 * 1000,
      placeholderData: { dashboardV2Enabled: false },
    }
  );
};

export default useCompanyDashboardConfig;
